<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <!-- 占位图 -->
    <div
      v-if="!isCollapse"
      style="width: 175px; height: 90px; margin: 20px auto 10px auto"
    >
      <img
        style="width: 100%; height: 100%; border-radius: 5px"
        src="../../../assets/images/sidebar.png"
      />
    </div>
    <div>
      {{
        pathHome && pathHome != "" && pathHome !== "/"
          ? pathHome.substring(1)
          : "home"
      }}
    </div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.name"
          :item="route"
          :base-path="pathHome + '/' + route.path"
          :activeMenu="activeMenu"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import defaultSettings from "@/settings";

export default {
  data() {
    return {
      pathHome: "", // 二级菜单前缀
    };
  },
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(["sidebar"]),
    routes() {
      if (defaultSettings.stateMenu) {
        // 动态获取左侧菜单
        return global.antRouter; // 把动态路由放进去
      } else {
        if (this.$store.state.settings.sidebarTopShow) {
          this.pathHome = this.$store.state.permission.currentRoutes.path;
          return this.$store.state.permission.currentRoutes.children;
        } else {
          return this.$router.options.routes;
        }
      }
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>
